import {
  Button,
  FONT_SIZES,
  tabletAndUpLinaria,
  Z_INDEXES,
} from '@aboutyou/ui-components';
import {styled} from '@linaria/react';
import React, {FC, PropsWithChildren} from 'react';

export const BorderedLinkText: FC<
  PropsWithChildren<{
    'data-testid'?: string;
  }>
> = ({'data-testid': dataTestId, children}) => {
  return (
    <StyledBorderedLinkText
      data-testid={dataTestId}
      aria-label={undefined}
      variant="glassy"
      size="fit-width"
    >
      {children}
    </StyledBorderedLinkText>
  );
};

const StyledBorderedLinkText = styled(Button)`
  &&& {
    font-size: ${FONT_SIZES.px14};
    margin-top: 4px;
    z-index: ${Z_INDEXES.TADARIDA_HEADER_IMG_TEASER_CTA};
    height: auto;
    padding: 10px 20px 11px;

    // the content of the button has white-space nowrap by default, we need display block here so the button can take the content space correctly
    display: block;

    & span {
      display: block;
    }
  }

  ${tabletAndUpLinaria(`
    font-size: ${FONT_SIZES.px16};
  `)}
`;
